/**
 * Feste Attribut-Codes der Bulk-Generierung (Kanal-Akkordeon-Checkboxen).
 *
 * Die alte Schnittmengen-Default-Logik (channel-übergreifend) entfällt seit
 * Spec 2026-07-24: jeder Channel hat jetzt seine eigene Feld-Auswahl, ein
 * globaler Default über alle Channels ist nicht mehr nötig.
 */

import type { BulkAttributeCode } from '@/lib/api/channel-content-bulk'

export const ALL_ATTRIBUTE_CODES: BulkAttributeCode[] = [
  'title',
  'description',
  'short_description',
  'bullets',
  'seo_title',
  'seo_description',
]
